// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XhsW2","button":"styles_button__BElRY","cookieImg":"styles_cookieImg__EHQO3"};